import React, { useState, useEffect, useMemo } from "react"

import _ from "lodash"
import ReactDOM from "react-dom"
import { View } from "react-native"
import { connect } from "react-redux"
import { useHistory } from "react-router-dom"
import { bindActionCreators } from "redux"

import {
  setPeopleSideBar,
  handleOpenSuggestion,
  handleCloseSuggestion,
  handleSetTeeupsMode,
} from "@actions/commonActions"
import { selectTeeupSearch, selectNotificationTeeups } from "@selectors/common"
import {
  DEFAULT_SORT,
  TEEUP_LIST_MODES,
  initialFiltersValues,
  teeupsFiltering,
  teeupSorting,
} from "@utils/teeupUtils"

import { setTeeupActive } from "../../actions/activeTeeupActions"
import {
  selectActiveTeeup,
  selectActiveTeeupId,
  selectDetailsOpen,
} from "../../selectors/activeTeeup"
import {
  selectActiveTeeups,
  selectArchivedTeeups,
  selectRemovedTeeups,
  selectTeeupsGameplans,
  selectUnseenTeeups,
} from "../../selectors/teeups"
import { selectToken, selectUserId } from "../../selectors/user"
import SortingAndFilter from "../SideFilterSortMenu"
import SuggestionContainer from "../TeeUpsOverview/SuggestionModal/SuggestionContainer"
import TeeupList from "../teeupList"
import TagButton from "../ui/tagButton"

import "./index.scss"
import TeeUpPageProvider from "../../pages/TeeUpPage/TeeUpPageContext/TeeUpPageContext"

const TeeUps = props => {
  const {
    activeTeeUpId,
    notificationTeeups,
    notifications,
    isDetailsOpen,
    param,
    activeTeeups,
    setPeopleSideBar,
    handleOpenSuggestion,
    handleCloseSuggestion,
    isSuggestionOpen,
    teeupsMode,
    teeupsState,
    teeups,
  } = props

  const [searchTerm, setSearchTerm] = useState("")
  // const [teeupsMode, setTeeupsMode] = useState(null)
  const [showFilter, setShowFilter] = useState(false)
  const [sorting, setSorting] = useState(DEFAULT_SORT)
  const [filtering, setFiltering] = useState(initialFiltersValues)
  const [contentHeight, setContentHeight] = useState(null)
  // const [isSuggestionOpen, setIsSuggestionOpen] = useState(false)
  const [content, setContent] = useState(null)
  const [suggestionListContent, setSuggestionListContent] = useState(null)

  const history = useHistory()

  useEffect(() => {
    if (param && activeTeeups.length > 0)
      setTeeupActive(activeTeeups.find(item => item.id === +param))
  }, [activeTeeups])

  const teeupList = useMemo(() => {
    if (teeupsMode === TEEUP_LIST_MODES.ARCHIVED) {
      return props.archivedTeeups
    }

    if (teeupsMode === TEEUP_LIST_MODES.SKIPPED) {
      return props.removedTeeups
    }

    return props.activeTeeups
  }, [
    props.archivedTeeups,
    props.removedTeeups,
    props.activeTeeups,
    teeupsMode,
  ])

  const sortedList = useMemo(() => {
    const { teeupsGameplans } = props
    if (!teeupsState) return
    const newList = teeupList.map(teeup => {
      const stateUpdateId = Object.keys(teeupsState).find(
        key => key === teeup.id.toString()
      )
      const stateUpdate = teeupsState[stateUpdateId]
      return {
        ...teeup,
        updatedat: stateUpdate ? stateUpdate.updatedAt : teeup.updatedat,
        updatedAt: stateUpdate ? stateUpdate.updatedAt : teeup.updatedat,
      }
    })

    const sorted = teeupSorting(newList, sorting, teeupsGameplans)

    return sorting.desc ? sorted.reverse() : sorted
  }, [sorting, teeupsMode, teeupList, teeupsState])

  const resetSortAndFilter = () => {
    setSorting(DEFAULT_SORT)
    setFiltering(initialFiltersValues)
  }

  const renderFilterButtons = teeupFiltering => {
    return (
      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {Object.values(teeupFiltering).map(filter => {
          if (filter.length === 0) return null
          return filter.map(button => (
            <TagButton
              key={`${button.id}`}
              onPress={() => {
                const { id, filterType } = button

                let currentFilter = [...teeupFiltering[filterType]]

                currentFilter = _.filter(
                  currentFilter,
                  value => value && value.id !== id
                )
                setFiltering({
                  ...teeupFiltering,
                  [filterType]: currentFilter,
                })
              }}
              value={button.title}
            />
          ))
        })}
      </View>
    )
  }

  const contentLayout = ({ nativeEvent }) => {
    const { height } = nativeEvent.layout
    setContentHeight(height)
  }

  const filterAndSortedData = useMemo(() => {
    const { userId, teeupsGameplans, teeupFilter } = props

    let teeupsData = teeupsFiltering(
      sortedList,
      filtering,
      userId,
      teeupsGameplans
    )

    if (notificationTeeups) {
      const notificationsArr = new Set(
        notifications.map(notification => notification.id)
      )
      return teeupsData.filter(teeup => notificationsArr.has(teeup.id))
    }

    if (teeupFilter) {
      return teeupsData.filter(
        (teeup = {}) =>
          teeup.name && teeup.name.match(new RegExp(teeupFilter, "i"))
      )
    }

    return teeupsData
  }, [
    props.userId,
    props.teeupsGameplans,
    props.teeupFilter,
    teeupsMode,
    notifications.length,
    teeups,
  ])

  // const handleOpenSuggestion = () => setIsSuggestionOpen(true);
  // const handleCloseSuggestion = () => setIsSuggestionOpen(false);

  return (
    <View
      style={{
        flexDirection: "row",
        height: "100%",
        flex: 1,
        position: "relative",
      }}
      onLayout={contentLayout}>
      {showFilter && (
        <SortingAndFilter
          closeMenu={() => setShowFilter(false)}
          teeupSorting={sorting}
          teeupFiltering={filtering}
          teeupsData={filterAndSortedData}
          addTeeupsSorting={setSorting}
          addTeeupsFiltering={setFiltering}
          clearTeeupsFiltering={resetSortAndFilter}
        />
      )}

      <div className="teeups-container">
        <TeeUpPageProvider>
          <TeeupList
            scrollEnabled={false}
            teeups={filterAndSortedData}
            searchTerm={searchTerm}
            teeupsMode={teeupsMode}
            sorting={sorting}
            openedSort={showFilter}
            toggleSort={setShowFilter}
            onRefresh={() => {}}
            onTeeupPressed={teeup => setTeeupActive(teeup)}
            emptyScrollEnabled={false}
            renderFilterButtons={renderFilterButtons(filtering)}
            addTeeupsSorting={setSorting}
            sortingType={sorting}
            teeupFilter={props.teeupFilter}
            resetSortAndFilter={resetSortAndFilter}
            param={param}
            history={history}
            // TODO prop drilling is not a good solution.consider moving stuff to contexts
            filtering={filtering}
            setFiltering={setFiltering}
          />
        </TeeUpPageProvider>
      </div>

      {isSuggestionOpen &&
        ReactDOM.createPortal(
          <SuggestionContainer
            activeTeeUp={props.activeTeeUp}
            handleCloseSuggestion={handleCloseSuggestion}
            content={content}
            setContent={setContent}
            suggestionListContent={suggestionListContent}
            setSuggestionListContent={setSuggestionListContent}
            setPeopleSideBar={setPeopleSideBar}
          />,
          document.querySelector("#modal-root")
        )}
    </View>
  )
}

const mapStateToProps = state => {
  return {
    all: state,
    activeTeeups: selectActiveTeeups(state),
    archivedTeeups: selectArchivedTeeups(state),
    removedTeeups: selectRemovedTeeups(state),
    token: selectToken(state),
    userId: selectUserId(state),
    activeTeeUpId: selectActiveTeeupId(state),
    teeupsGameplans: selectTeeupsGameplans(state),
    activeTeeUp: selectActiveTeeup(state),
    teeupFilter: selectTeeupSearch(state),
    notificationTeeups: selectNotificationTeeups(state),
    notifications: selectUnseenTeeups(state),
    isDetailsOpen: selectDetailsOpen(state),
    isSuggestionOpen: state.common.isSuggestionOpen,
    teeupsMode: state.common.teeupsMode,
    teeupsState: state.teeupsState.teeups,
    teeups: state.teeups.teeups,
  }
}

const mapDispatchToProps = dispatch => ({
  setTeeupActive: bindActionCreators(setTeeupActive, dispatch),
  setPeopleSideBar: bindActionCreators(setPeopleSideBar, dispatch),
  handleOpenSuggestion: bindActionCreators(handleOpenSuggestion, dispatch),
  handleCloseSuggestion: bindActionCreators(handleCloseSuggestion, dispatch),
  handleSetTeeupsMode: bindActionCreators(handleSetTeeupsMode, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(TeeUps)
